<div class="app-foot">
    <div class="app-foot">
        <div class="app-foot-links">
            <span>
                <a href='/Homeowner-Resources/FAQ' target='_blank' class="app-foot-link">FREQUENTLY ASKED QUESTIONS</a>
            </span>
        </div>
    </div>
  </div>
